import { render, staticRenderFns } from "./signingPreferential.vue?vue&type=template&id=982a7896&scoped=true&"
import script from "./signingPreferential.vue?vue&type=script&lang=js&"
export * from "./signingPreferential.vue?vue&type=script&lang=js&"
import style0 from "./signingPreferential.vue?vue&type=style&index=0&id=982a7896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "982a7896",
  null
  
)

export default component.exports